export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref7492.41ea643b.jpg";